import { useState, type FormEvent } from "react";
import { api } from "../api";
import type { User } from "../types";

/**
 * Login only - there is no registration route, by design. Pilot accounts are
 * created by hand, so a sign-up form would be a door with nothing behind it.
 */
export function Login({ onLogin }: { onLogin: (user: User) => void }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      onLogin(await api.login(email.trim(), password));
    } catch (err) {
      setError(err instanceof Error ? err.message : "Autentificare eșuată");
      setPassword("");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="centered">
      <form className="auth-card login" onSubmit={submit}>
        <h1 className="auth-brand">
          <span className="logo" aria-hidden="true">a</span>
          arhilex
        </h1>
        <p className="muted">Asistent de cercetare juridică — pilot privat</p>

        <label htmlFor="email">Email</label>
        <input
          id="email"
          type="email"
          autoComplete="username"
          required
          autoFocus
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <label htmlFor="password">Parolă</label>
        <input
          id="password"
          type="password"
          autoComplete="current-password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        {error && (
          <p className="error" role="alert">
            {error}
          </p>
        )}

        <button type="submit" className="btn primary" disabled={busy || !email || !password}>
          {busy ? "Se verifică…" : "Intră"}
        </button>

        <p className="fineprint">
          Accesul este limitat la conturile create pentru pilot. Pentru
          probleme de acces, contactați echipa ArhiLex.
        </p>
      </form>
    </div>
  );
}
